import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { useTranslate } from 'react-admin';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  btnCancel: {
    fontFamily: 'UniviaPro',
    fontSize: '10px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.25,
    letterSpacing: '0.4px',
    // color: theme.overrides.MuiButton.textPrimary.color,
    cursor: 'pointer',
    verticalAlign: 'bottom'
  },
}));

export default function TextButton(props) {
  const classes = useStyles();
  const translate = useTranslate()

  return (
    <Button {...props} color='primary'>
      <Typography className={classes.btnCancel}>
        {props.children || translate(`pos.dashboard.CANCEL`)}</Typography>
    </Button>
  );
}